import { render, staticRenderFns } from "./Jubilaciones.vue?vue&type=template&id=60655f1c&"
import script from "./Jubilaciones.vue?vue&type=script&lang=js&"
export * from "./Jubilaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports